import React from 'react'
import Header from '../_components/common/Header'
import ReportHistoryUI from '../_components/UI/ReportHistoryUI'

const ReportHistory = () => {
  return (
    <div className='page-main'>
        <Header name = {["Report History"]} />
        <ReportHistoryUI />


    </div>
  )
}

export default ReportHistory